import styled from 'styled-components'

export const StyledPreviewContainer = styled.div`
  position: relative;
  top: 0px;
  left: 0px;
  margin: auto;
  width: ${({ width }) => width}px;
  height: 100%;
`
